var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 42,
    viewBox: "0 0 32 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0V2H6C2.6863 2 0 4.6863 0 8V14C0 19.5228 4.47716 24 10 24H22C27.5228 24 32 19.5228 32 14V8C32 4.6863 29.3138 2 26 2H18V0H14ZM4 8C4 6.89544 4.89544 6 6 6H26C27.1046 6 28 6.89544 28 8V14C28 17.3137 25.3138 20 22 20H10C6.6863 20 4 17.3137 4 14V8ZM11 16C12.6568 16 14 14.6569 14 13C14 11.3431 12.6568 10 11 10C9.34314 10 8 11.3431 8 13C8 14.6569 9.34314 16 11 16ZM21 16C22.6568 16 24 14.6569 24 13C24 11.3431 22.6568 10 21 10C19.3432 10 18 11.3431 18 13C18 14.6569 19.3432 16 21 16ZM4 42C4 35.3726 9.37258 30 16 30C22.6274 30 28 35.3726 28 42H32C32 33.1634 24.8366 26 16 26C7.16344 26 0 33.1634 0 42H4Z",
    fill: "url(#paint0_linear_25532_2023)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25532_2023",
    x1: 0,
    y1: 0,
    x2: 24.0819,
    y2: 36.6962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD2BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefi);
export default __webpack_public_path__ + "static/media/defi.a0007623bdd8995178b3b185c3a9e26c.svg";
export { ForwardRef as ReactComponent };